import axios from 'axios';
import Cookies from "js-cookie";

const service = axios.create({timeout: 60000});
import {message, notification} from 'ant-design-vue';
import 'ant-design-vue/lib/date-picker/style/css'; // 加载 CSS
import {MessageBox} from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import {logout} from "@/api/login";

config => {

    return config;
},
    error => {
        // console.log(error);
        return Promise.reject();
    }
// request拦截器
service.interceptors.request.use(
    config => {
        // config.headers['content-type'] = 'multipart/form-data;charset=UTF-8'
        // 设置请求头
        if (Cookies.get('JobseekerAuthorization')) {
            config.headers['JobseekerAuthorization'] = Cookies.get('JobseekerAuthorization')
        }
        if (Cookies.get('CompanyAuthorization')) {
            config.headers['CompanyAuthorization'] = Cookies.get('CompanyAuthorization')
        }
        return config
    },
    error => {
        // console.log(error)
        Promise.reject(error)
    }
)
let messageBoxFlag = 0 // 默认 MessageBox 未打开
let messageBoxFlag1 = 0
let messageBoxFlag2 = 0
let messageBoxFlag3 = 0
let messageBoxFlag4 = 0
// 响应拦截器
service.interceptors.response.use(
    response => {
        // console.log(response.request.responseURL, response.data, "请求接口");
        if (response.status === 200) {

            if (response.data.status == 201) {

                if (response.data.msg == "用户不存在，请重新登陆") {
                    Cookies.remove('JobseekerAuthorization')
                    Cookies.remove('CompanyAuthorization')
                    sessionStorage.removeItem('Refresh')
                    window.location.href = '/'
                }
                if (Cookies.get('JobseekerAuthorization') || Cookies.get('CompanyAuthorization')) {
                    // Message.confirm(response.data.msg, '提示', {
                    //     confirmButtonText: '确定',
                    //     cancelButtonText: '取消',
                    //     type: 'warning'
                    // }).then(() => {
                    // }).catch(() => {
                    // });
                    if (messageBoxFlag === 0) {
                        messageBoxFlag = 1 // 修改标记，打开 MessageBox
                        MessageBox.confirm(response.data.msg, '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'error'
                        }).then(() => {
                            messageBoxFlag = 0  // 修改标记
                        }).catch(() => {
                            messageBoxFlag = 0  // 修改标记
                        })
                    }
                } else {
                    if (response.data.msg == '未认证,请在前端系统进行认证' || response.data.msg == '未认证，请在前端系统进行认证') {
                        // Message.confirm("登陆已过期，请重新登录！", '提示', {
                        //     confirmButtonText: '确定',
                        //     cancelButtonText: '取消',
                        //     type: 'warning'
                        // }).then(() => {
                        //     // window.location.reload()
                        //     window.location.href='/'
                        // }).catch(() => {
                        // });
                        if (messageBoxFlag1 === 0) {
                            messageBoxFlag1 = 1 // 修改标记，打开 MessageBox
                            MessageBox.confirm('登录已过期，请重新登录！', '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'error'
                            }).then(() => {
                                messageBoxFlag1 = 0  // 修改标记
                                logout().then((res) => {
                                    console.log(res);
                                    if (res.status == 200) {
                                        if (res.status == 200) {
                                            this.$router.push({path: "/login"});
                                        }
                                    }
                                });
                                sessionStorage.removeItem('Refresh')
                                Cookies.remove("JobseekerAuthorization");
                                Cookies.remove("CompanyAuthorization");
                            }).catch(() => {
                                messageBoxFlag1 = 0  // 修改标记
                            })
                        }
                    } else {
                        // Notify.warning({
                        //     message: response.data.msg,
                        //     description:
                        //     response.data.msg,
                        // });
                        if (messageBoxFlag2 === 0) {
                            messageBoxFlag2 = 1 // 修改标记，打开 MessageBox
                            MessageBox.confirm(response.data.msg, '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'error'
                            }).then(() => {
                                messageBoxFlag2 = 0  // 修改标记
                            }).catch(() => {
                                messageBoxFlag2 = 0  // 修改标记
                            })
                        }
                    }

                }


            }
            if (response.data.status == 401) {
                // Notify.warning({
                //     message: "暂未登录或登录已过期",
                //     description:
                //         "暂未登录或登录已过期",
                // });
                if (messageBoxFlag3 === 0) {
                    messageBoxFlag3 = 1 // 修改标记，打开 MessageBox
                    MessageBox.confirm('暂未登录或登录已过期', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'error'
                    }).then(() => {
                        messageBoxFlag3 = 0  // 修改标记
                    }).catch(() => {
                        messageBoxFlag3 = 0  // 修改标记
                    })
                }
            }
            if (response.data.status == 403) {
                // Notify.warning({
                //     message: "没有相关权限",
                //     description:
                //         "没有相关权限",
                // });
                if (messageBoxFlag4 === 0) {
                    messageBoxFlag4 = 1 // 修改标记，打开 MessageBox
                    MessageBox.confirm('没有相关权限', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'error'
                    }).then(() => {
                        messageBoxFlag4 = 0  // 修改标记
                    }).catch(() => {
                        messageBoxFlag4 = 0  // 修改标记
                    })
                }
            }
            return response.data;
        } else {

            Promise.reject();
        }
    },
    error => {
        message.error('服务器端错误')
        console.log(error, "错误");
        return Promise.reject();
    }
)
;

export default service;
